import React from 'react';
import Baby1 from '../../../../../images/bookingDetailAvatars/baby.svg';
import Baby2 from '../../../../../images/bookingDetailAvatars/baby_2.svg';
// import Baby1 from '../../../../../images/bookingDetailAvatars/baby_3.svg';

const BabyAvatar = () => {
    const avatars = [Baby1, Baby2];
    const randomIndex = Math.floor(Math.random() * avatars.length);
    const selectedAvatar = avatars[randomIndex];

    return (
        <img
            src={selectedAvatar}
            className='booking-guest__avatar'
            alt='avatar baby guest'
        />
    );
};

export default BabyAvatar;
